import { logo } from "../shared/Images.js";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  return (
    <div className="row menu-wrap">
      <nav className="navbar navbar-expand-md w-100">
        <a className="navbar-brand m-0" href="#">
          <img src={logo} alt="gauweng-sa-logo" className="img-fluid" />
        </a>
        <button
          className="navbar-toggler p-0"
          type="button"
          data-toggle="collapse"
          data-target="#navigator"
          aria-controls="navigator"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon fa fa-bars"></span>
        </button>

        <div className="collapse navbar-collapse" id="navigator">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <Link
                className={`nav-link ${
                  location.pathname === "/" ? "active" : ""
                }`}
                to="/"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/about" ? "active" : ""
                }`}
                to="/about"
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/products" ? "active" : ""
                }`}
                to="/products"
              >
                Products
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/contact" ? "active" : ""
                }`}
                to="/contact"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Header;
